import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTE_PATHS } from '@hero/routes';

import * as S from './style';

export const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <S.NotFound>
      <S.NotFoundImage>
        <Image name="notFound" alt="not-found" />
      </S.NotFoundImage>
      <S.NotFoundInformation>
        <Typography variant="subtitle1Bold">{t('pageNotFound')}</Typography>
        <Typography variant="subtitle3">{t('notFoundPageText')}</Typography>
      </S.NotFoundInformation>
      <Button onClick={() => navigate(ROUTE_PATHS.HOME)}>{t('goBackHome')}</Button>
    </S.NotFound>
  );
};
